import React from 'react';
import { Avatar, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  avatar: {
    fontSize: ({ size }) => size * 0.4,
    fontWeight: '600',
    backgroundColor: ({ image }) => !image ? '#1976d2' : 'transparent',
    color: ({ image }) => !image ? 'white' : 'inherit',
    border: ({ showBorder }) => showBorder ? '2px solid #e0e0e0' : 'none',
    boxShadow: ({ elevation }) => elevation ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
  }
}));

const TeacherAvatar = ({ 
  teacher, 
  size = 56, 
  showBorder = true, 
  elevation = true 
}) => {
  const { firstName, lastName, image } = teacher;
  const name = `${firstName} ${lastName}`;
  const initials = name.split(' ').map(n => n[0]).join('').toUpperCase();
  const classes = useStyles({ size, showBorder, elevation, image });

  // Determinar la URL de la imagen
  const getImageUrl = (image) => {
    if (!image) return undefined;
    
    // Si la imagen ya es una URL completa (DigitalOcean Spaces), usarla directamente
    if (image.startsWith('http')) {
      return image;
    }
    
    // Si es solo un nombre de archivo, usar la ruta local
    return `/images/teachers/${image}`;
  };

  return (
    <Avatar 
      alt={name} 
      src={getImageUrl(image)}
      className={classes.avatar}
      style={{ 
        width: size, 
        height: size,
      }}
      onError={(e) => {
        // Si falla cargar la imagen, ocultar el elemento img
        e.target.style.display = 'none';
      }}
    >
      {!image && initials}
    </Avatar>
  );
};

export default TeacherAvatar;